import ExcelJS from 'exceljs';
import { toCamelCase } from './toCamelCase';
import { stripHtmlAndExtractColor } from './stripHtmlAndExtractColor';
import { Modal as customModal } from 'antd';

export const downloadTable = async (drillPathDataMap, fileName,levelwisehead) => {
  console.log(levelwisehead,"levelwiseheads")
  console.log(drillPathDataMap, "drillPathDataMap");

  const levels = Object.keys(drillPathDataMap).sort((a, b) => {
    return Number(a.replace('level', '')) - Number(b.replace('level', ''));
  });
const getOriginalHeaderKey = (key, level) => {
  const headers = levelwisehead[`level${level}`] || [];
  return (
    headers.find(originalKey => originalKey.toLowerCase() === key.toLowerCase()) ?? key
  );
};
  const hasData = levels.some(lvl => drillPathDataMap[lvl]?.length > 0);
  console.log(hasData,"hasData")
  if (!hasData) {
    customModal.warning({
      title: 'Oops',
      content: 'No data available to export.',
      centered: true,
      cancelButtonProps: { style: { display: 'none' } },
      maskClosable: false,
    });
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Report');
  let currentRow = 0;
  for (const levelKey of levels) {
    const reportData = drillPathDataMap[levelKey];
    if (!reportData || reportData.length === 0) continue;
    currentRow++; 
   const headers = Object.keys(reportData[0] || {}).filter(h => h !== 'drilldownquery');
 
    const headerRow = worksheet.getRow(currentRow++);
headers.forEach((header, i) => {
  const cell = headerRow.getCell(i + 1);
  const originalHeader = getOriginalHeaderKey(header, levelKey.replace('level', '')); 
  cell.value = originalHeader;
  cell.font = { bold: true };
  cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
});

    
    for (const rowItem of reportData) {
      const row = [];
      const styles = [];

     headers.forEach((key, index) => {
  const { text, color, bold, backgroundColor } = stripHtmlAndExtractColor(rowItem[key]);


  const cleanText = text.replace(/<br\s*\/?>/gi, '\n');

  row.push(cleanText);
  styles.push({
    font: {
      color: color ? { argb: color.replace('#', '') } : undefined,
      bold: bold || false,
    },
    fill: backgroundColor
      ? {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: backgroundColor.replace('#', '') },
        }
      : undefined,
    alignment: {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true, 
    },
  });
});


      const newRow = worksheet.getRow(currentRow++);
      row.forEach((val, i) => {
        const cell = newRow.getCell(i + 1);
        cell.value = val;
        cell.style = styles[i];
      });
    }

    currentRow++; 
  }

  const globalMaxLengths = {};

  worksheet.eachRow((row) => {
    row.eachCell((cell, colNumber) => {
      const len = cell.value ? cell.value.toString().length : 0;
      globalMaxLengths[colNumber] = Math.max(globalMaxLengths[colNumber] || 10, len + 2);
    });
  });

  Object.entries(globalMaxLengths).forEach(([colNumber, width]) => {
    worksheet.getColumn(Number(colNumber)).width = width;
  });


  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();
  const hrs = String(today.getHours()).padStart(2, '0');
  const mins = String(today.getMinutes()).padStart(2, '0');

  const newfilename =
    fileName.indexOf(' ') > -1
      ? `${fileName.replaceAll(' ', '_')}_${yyyy}${mm}${dd}_${hrs}${mins}`
      : `${fileName}_${yyyy}${mm}${dd}_${hrs}${mins}`;


  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = newfilename;
    link.click();
    window.URL.revokeObjectURL(link.href);
  });

  console.log(`File saved as ${newfilename}`);
};